/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../../_chunks/dep-8c39d78a.mjs';
import '../../../_chunks/dep-556a2f2c.mjs';

function swapDragArrayElement(data, currentIndex, targetIndex) {
  var newData = _toConsumableArray(data);

  if (targetIndex - currentIndex > 0) {
    newData.splice(targetIndex + 1, 0, newData[currentIndex]);
    newData.splice(currentIndex, 1);
  } else {
    newData.splice(targetIndex, 0, newData[currentIndex]);
    newData.splice(currentIndex + 1, 1);
  }

  return newData;
}

export { swapDragArrayElement as default };
//# sourceMappingURL=swapDragArrayElement.mjs.map
